import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import VuetifyPt from 'vuetify/es5/locale/pt'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    locales: { pt: VuetifyPt },
    current: 'pt'
  },
  theme: {
    primary: '#ffc107',
    secondary: '#783534',
    tertiary: '#495057',
    accent: '#ffa014',
    error: '#FF5252',
    info: '#26E3DB',
    success: '#8CE326',
    warning: '#FFC107'
  }
})
